import React, { useState } from 'react';
import './TopFold.css';
import webcafeBeer from '../assets/images/webcafe-beer-v1.png';
//import { FaRegPlayCircle } from 'react-icons/fa';

import Banner from '../components/Banner';
import Modal from '../components/Modal'; // Import the Modal component

const TopFold = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');

  // List of random YouTube video IDs
  const videoList = [
    'hAyPTJFgFEs', // Example video ID (You can replace this with your own list)
    'ApXoWvfEYVU',
    'TO-_3tck2tg',
    '7_EeCkHs-e0',
    'e2oRqyn7ToQ'
  ];

  // Function to open the modal and select a random video
  const openModal = () => {
    const randomVideo = videoList[Math.floor(Math.random() * videoList.length)];
    setVideoUrl(`https://www.youtube.com/embed/${randomVideo}?autoplay=1`);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setVideoUrl('');
  };

  return (
    <div className='topfold-container'>
      <div className="topfold">
        {/* Hero Section */}
        <div className="hero-section">
          <h1 className='hero-title'>
            {'Krish.me'}
          </h1>
          <p className="hero-subtitle">
            Hello Everyone! I'm Krish, I am still a Kid.  I have asked my dad to maintain this site for me until I grow up.
          </p>
          <div className="cta-buttons">
            <button className='watchdemo-btn' onClick={openModal}>
              {/*<FaRegPlayCircle className="play-icon" />*/}
              <div className='demo-text'>
                <span><b>Some of My Favorite Music</b></span>
                <span className='demo-duration'>clik to listen</span>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Use the Modal component here */}
      <Modal isOpen={isModalOpen} closeModal={closeModal} videoUrl={videoUrl} />
    </div>
  );
};

export default TopFold;